import React, { useState, useEffect } from 'react';
import { useLocation, matchPath } from 'react-router';

import { Modal } from 'components/_shared/Modal';
import { Button } from 'components/_shared/Button';
import { events } from '_events';
import {
  ROUTES,
  PERMISSION_ERROR,
  SERVER_ERROR,
  SIZE_ERROR,
  DEFAULT_ERROR,
  NOT_FOUND
} from '_constants';

import { ButtonWrapper } from './ErrorModal.styles';

const catchErrRoutes = [
  ROUTES.AUTH,
  ROUTES.SIGN_UP,
  ROUTES.RESET_PASSWORD,
  ROUTES.FORGOT_PASSWORD,
  ROUTES.CONFIRM_PASSWORD
];

export const ErrorModal = () => {
  const [error, setError] = useState(null);
  const [errorText, setErrorText] = useState('');
  const location = useLocation();

  useEffect(() => {
    return events.onToggleErrorModal(({ error }) => {
      const isIgnoreError =
        catchErrRoutes.some(route => matchPath(location.pathname, route)) &&
        error.status === 400;

      if (error.config?.method === 'get' || isIgnoreError) {
        setError(null);
        return;
      }
      setError(error);
      if (typeof error === 'string') {
        setErrorText(error);
      } else {
        if (error.status === 403) {
          if (error.data.errorCode === 603) {
            setErrorText(SIZE_ERROR);
          } else {
            setErrorText(PERMISSION_ERROR);
          }
        } else if (error.status === 404) {
          setErrorText(NOT_FOUND);
        } else if (error.status >= 500) {
          setErrorText(SERVER_ERROR);
        } else {
          setErrorText(error.data?.name?.[0] || Object.values(error.data)?.[0][0]);
        }
      }
    });
  }, [location]);

  const handleCloseModal = () => setError(null);

  return (
    error && (
      <Modal close={handleCloseModal} textCenter={true}>
        <div>{errorText ?? DEFAULT_ERROR}</div>
        <ButtonWrapper>
          <Button variant='secondary' onClick={handleCloseModal}>
            Close
          </Button>
        </ButtonWrapper>
      </Modal>
    )
  );
};
